import { Box } from '@chakra-ui/react';
import StandardLink from '@components/atoms/StandardLink';
import Button, { ButtonVariants } from '@components/interactive/Button';
import Body1 from '@components/typography/Body1';
import TypographyHeader from '@components/typography/Header';
import { Routes } from '@constants/routes';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

const PositiveSurveyResult = ({ userId }) => (
  <Box mt={4}>
    <TypographyHeader as="h3">We're Thrilled You're Happy with Your Plan.</TypographyHeader>
    <br />
    <Body1 fontSize="xl">If you have any questions about your plan, get in touch with us.</Body1>
    <Body1 fontSize="xl" display="inline-block">
      Email us here: &nbsp;
    </Body1>
    <StandardLink fontSize="xl" href="mailto:agents@fairsquaremedicare.com" text="agents@fairsquaremedicare.com." />
    <br />
    <br />
    <Box display="inline-block">
      <Body1 fontSize="xl">Help us grow! Refer a friend or family member.</Body1>
      <Button
        variant={ButtonVariants.secondary}
        ml={2}
        faIcon={faEnvelope}
        href={`${Routes.invite}?userId=${userId}&source=plan-satisfaction-survey`}
        size="sm"
      >
        Refer Us
      </Button>
    </Box>
  </Box>
);

export default PositiveSurveyResult;
